<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations/corporate-governance/governance-committee-charter',
    'fr-CA': '/relations-avec-investisseurs/gouvernance-entreprise/charte-comite-gouvernance'
  }
})

useHead({
  title: t('navigation.governanceCommitteeCharter.metatitle'),
  meta: [{ name: 'description', content: t('navigation.governanceCommitteeCharter.metadescription') }]
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-investorRelations')">{{ $t('navigation.investorRelations.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-corporateGovernance')">{{ $t('navigation.corporateGovernance.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.governanceCommitteeCharter.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.governanceCommitteeCharter.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuInvestorRelations />
        <div class="contenu right">
          <div v-if="$i18n.locale == 'en-CA'"
               class="">
            <a href="/documents/governance-committee-charter.pdf"
               target="_blank">Click to view Kruger Products Inc. Governance Committee Charter</a>
          </div>
          <div v-if="$i18n.locale == 'fr-CA'"
               class="">
            <a href="/documents/governance-committee-charter.pdf"
               target="_blank">Cliquez pour voir la charte du comité de gouvernance de Produits Kruger Inc.</a>
            <span class=" caption">(Anglais seulement)</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
